// Motor puro do rodízio de ativos (nenhum import de Vue, store ou router):
// dado o id do ativo em tela e a lista de ids que estão "na roda", decide
// qual é o próximo. Usado pela fase 1 (lista = todos os ativos, ver
// CmaDashboard.vue) e pensado para ser reaproveitado pela fase 3 (lista =
// favoritos) — só a fonte de `ids` muda entre as duas, ver
// docs/specs/cma-ativos-favoritos-rodizio.md §1.1 e §3.8.

// Menos de 2 ids: não há para onde girar. `currentId` presente na lista:
// avança para o seguinte, em círculo. Ausente (ex.: navegação manual para
// fora da lista, ou o próprio id caiu da lista): retoma de onde a última
// rotação parou (`lastRotationIndex`), ou do primeiro se esse índice não
// existir mais.
// eslint-disable-next-line import/prefer-default-export
export function nextRotationId(ids, currentId, lastRotationIndex) {
  if (!Array.isArray(ids) || ids.length < 2) return null;

  const currentIndex = ids.indexOf(currentId);
  if (currentIndex !== -1) {
    return ids[(currentIndex + 1) % ids.length];
  }

  const resumeIndex = lastRotationIndex >= 0 && lastRotationIndex < ids.length
    ? lastRotationIndex
    : 0;
  return ids[resumeIndex];
}
